export default __webpack_public_path__ + "static/rentals-1427d12deae20e0547579e72a9388b9c.jpg";